import React from 'react'
import * as Yup from 'yup'
import defaultScanScript from './deafultValue'

const formView = (defaultValues, value) => [
  {
    name: 'product_profile_name',
    label: 'Profile Name',
    placeholder: 'Enter profile name',
    type: 'Input',
    className: 'w-[50%]',
    defaultValue: defaultValues?.product_profile_name,
    validation: Yup.string().required('Name is required'),
  },
  /*{
        name: "product_profile_name",
        label: "Load from List",
        placeholder: "Enter profile name",
        type: "Select",
        api: "/api/product-profiles",
        className: "w-[50%]",
        defaultValue: defaultValues?.product_profile_name,
    },*/
  {
    name: 'description',
    label: 'Description',
    placeholder: 'Enter description',
    type: 'Input',
    defaultValue: defaultValues?.description,
    validation: Yup.string().required('Description is required'),
  },
  {
    name: 'user_scan_script',
    label: 'Scan Script',
    type: 'Textarea',
    placeholder: 'Enter scan script',
    defaultValue: defaultValues?.user_scan_script || defaultScanScript,
    validation: Yup.string().required('User scan script is required'),
  },
  {
    name: 'lumia_lase_script',
    label: 'Lumia Laser Script',
    type: 'Textarea',
    lines: 5,
    placeholder: 'Enter lumia laser script',
    defaultValue: defaultValues?.lumia_lase_script || 'EMPTY',
    validation: Yup.string().required('Lumia script is required'),
  },
  {
    name: 'job_parameters',
    label: 'Job Parameters',
    type: 'Textarea',
    placeholder: 'Enter job parameters',
    defaultValue: defaultValues?.job_parameters || '{"version":1}',
    validation: Yup.string().test('is-json', 'Invalid JSON format', (value) => {
      try {
        JSON.parse(value)
        return true
      } catch (e) {
        return false
      }
    }),
  },
  {
    name: 'start_group',
    label: 'Advance',
    //description: 'Group is here',
    type: 'Group',
    child: ['user_scan_script', 'lumia_lase_script', 'job_parameters'],
    toggle: true,
    layoutStyle: 'py-xl px-xl flex flex-col gap-md',
  }
  
]

export default formView
